import { readFileSync } from 'fs';
import { dirname, join } from 'path';
import { fileURLToPath } from 'url';

const PACKAGE_NAME = '@testdino/playwright';
export const UNRESOLVED_VERSION = '0.0.0';

// Resolves in both the CJS and ESM bundles: import.meta.url is unavailable in one
// and __dirname in the other, so try each.
function getModuleDir(): string {
  const metaUrl = typeof import.meta === 'object' ? import.meta?.url : undefined;
  if (metaUrl) return dirname(fileURLToPath(metaUrl));
  return __dirname;
}

export function getPackageVersion(): string {
  // dist/index.js and dist/cli/index.mjs sit at different depths under the package root.
  const candidates = ['../package.json', '../../package.json'];

  for (const candidate of candidates) {
    try {
      const raw = readFileSync(join(getModuleDir(), candidate), 'utf-8');
      const parsed = JSON.parse(raw) as { name?: unknown; version?: unknown };
      if (parsed.name === PACKAGE_NAME && typeof parsed.version === 'string') {
        return parsed.version;
      }
    } catch {
      continue;
    }
  }
  return UNRESOLVED_VERSION;
}
